import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CustomButton from '../CustomButton/CustomButton';
import { CircularProgress } from '@mui/material';

interface Props {
	open: boolean;
	setOpen: (value: boolean) => void;
	disable: boolean;
	description: string;
	handleClose: () => void;
	handleYes: () => void;
	image?: string | null;
}

export default function CustomDialog({
	open,
	setOpen,
	disable = false,
	description = 'Are you sure you want delete this',
	handleClose,
	handleYes,
	image = null,
}: Props) {
	const handleClickOpen = () => {
		setOpen(true);
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{image && <img src={image} alt="dialog" />}
						{description}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<CustomButton
						title="No"
						handleClick={handleClose}
						color="secondary"
						styles={{
							width: '80px',
							height: '36px',
						}}
					/>
					<CustomButton
						title={
							disable ? (
								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
							) : (
								'Yes'
							)
						}
						handleClick={handleYes}
						color="primary"
						disabled={disable}
						styles={{
							width: '80px',
							height: '36px',
						}}
					/>
				</DialogActions>
			</Dialog>
		</div>
	);
}
